import {
  API_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_SUCCESS,
  CREATE_ADMIN_USER,
  CREATE_ADMIN_USER_FAILED,
  CREATE_ADMIN_USER_SUCCESS,
  DELETE_ADMIN_USER_SUCCESS,
  GET_BUSINESS_UNITS_SUCCESS,
  GET_EVENT_TEASER,
  GET_EVENT_TEASER_SUCCESS,
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_ROLES_SUCCESS,
  GET_USER_PROFILE_SUCCESS,
  HIDE_CHANGE_PASSWORD_FAILURE_MODAL,
  HIDE_CHANGE_PASSWORD_MODAL,
  HIDE_PWD_SECURITY_CHECK_MODAL,
  OPEN_CHANGE_PASSWORD_FAILURE_MODAL,
  OPEN_CHANGE_PASSWORD_MODAL,
  OPEN_PWD_SECURITY_CHECK_MODAL,
  PWD_SECURITY_CHECK,
  PWD_SECURITY_CHECK_FAILED,
  PWD_SECURITY_CHECK_SUCCESS,
  RESET_EVENT_TEASER,
  RESET_USER_PROFILE,
  UPDATE_ADMIN_USER_SUCCESS,
  UPDATE_PROFILE,
  UPDATE_PROFILE_META_TAGS,
  UPDATE_PROFILE_META_TAGS_SUCCESS,
  UPDATE_PROFILE_SUCCESS,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  profile: null,
  saveLoading: false,
  roles: [],
  changePasswordModalIsOpen: false,
  changePasswordFailureModalIsOpen: false,
  changePasswordInProgress: false,
  eventTeaser: [],
  userProfile: null,
  pwdSecurityCheckLoading: false,
  pwdSecurityCheckModalIsOpen: false,
}

const profile = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILE:
    case GET_EVENT_TEASER:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_PROFILE_SUCCESS:
      state = {
        ...state,
        loading: false,
        profile: action.payload,
      }
      break
    case UPDATE_PROFILE:
    case UPDATE_PROFILE_META_TAGS:
      state = {
        ...state,
        saveLoading: true,
      }
      break
    case UPDATE_PROFILE_SUCCESS:
    case CREATE_ADMIN_USER_SUCCESS:
    case UPDATE_ADMIN_USER_SUCCESS:
      state = {
        ...state,
        saveLoading: false,
        profile: action.payload,
      }
      break
    case UPDATE_PROFILE_META_TAGS_SUCCESS:
      state = {
        ...state,
        saveLoading: false,
        profile: {
          ...state.profile,
          tags: action.payload?.tags || [],
        },
      }
      break
    case GET_ROLES_SUCCESS:
      state = {
        ...state,
        roles: action.payload,
      }
      break

    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        saveLoading: false,
      }
      break
    case OPEN_CHANGE_PASSWORD_MODAL:
      return {
        ...state,
        changePasswordModalIsOpen: true,
      }
    case HIDE_CHANGE_PASSWORD_MODAL:
      return {
        ...state,
        changePasswordModalIsOpen: false,
      }
    case OPEN_CHANGE_PASSWORD_FAILURE_MODAL:
      return {
        ...state,
        changePasswordFailureModalIsOpen: true,
      }
    case HIDE_CHANGE_PASSWORD_FAILURE_MODAL:
      return {
        ...state,
        changePasswordFailureModalIsOpen: false,
      }
    case CHANGE_PASSWORD:
      return {
        ...state,
        changePasswordInProgress: true,
      }
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePasswordInProgress: false,
        changePasswordModalIsOpen: false,
      }
    case CHANGE_PASSWORD_FAILED:
      return {
        ...state,
        changePasswordInProgress: false,
        changePasswordModalIsOpen: false,
        changePasswordFailureModalIsOpen: true,
      }
    case GET_EVENT_TEASER_SUCCESS:
      return {
        ...state,
        eventTeaser: action.payload,
        loading: false,
      }
    case RESET_EVENT_TEASER:
      return {
        ...state,
        eventTeaser: [],
      }
    case DELETE_ADMIN_USER_SUCCESS:
      return {
        ...state,
        profile: { ...state.profile, type: 0, role: [] },
      }
    case GET_USER_PROFILE_SUCCESS:
      return {
        ...state,
        userProfile: action.payload,
      }
    case RESET_USER_PROFILE:
      return {
        ...state,
        userProfile: null,
      }
    case OPEN_PWD_SECURITY_CHECK_MODAL:
      return {
        ...state,
        pwdSecurityCheckModalIsOpen: true,
      }
    case HIDE_PWD_SECURITY_CHECK_MODAL:
      return {
        ...state,
        pwdSecurityCheckModalIsOpen: false,
      }
    case PWD_SECURITY_CHECK:
      return {
        ...state,
        pwdSecurityCheckLoading: true,
      }
    case PWD_SECURITY_CHECK_SUCCESS:
      return {
        ...state,
        pwdSecurityCheckModalIsOpen: action.payload?.is_correct ? false : true,
        changePasswordModalIsOpen: action.payload?.is_correct ? true : false,
        pwdSecurityCheckLoading: false,
      }
    case PWD_SECURITY_CHECK_FAILED:
      return {
        ...state,
        pwdSecurityCheckLoading: false,
      }
    default:
      state = { ...state }
      break
  }
  return state
}

export default profile
